import settings from "./settings/reducer";
import menu from "./menu/reducer";
import authUser from "./auth/reducer";
import projects from "./projects/reducer";
import currentProject from "./project/reducer";
import admin from "./admin/reducer";
import media from "./media/reducer";
import modal from "./modal/reducer";
import projectEditor from "./projectEditor/reducer";
import reports from "./reports/reducer";
import dashboard from "./dashboard/reducer";
import billingAndPlans from "./billingAndPlans/reducer";

const reducers = {
  menu,
  settings,
  authUser,
  projects,
  currentProject,
  admin,
  media,
  modal,
  projectEditor,
  reports,
  dashboard,
  billingAndPlans,
};

export default reducers;
